"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionalFilteredGalleryRankingWidgetDataSchema = exports.RegionalFilteredGalleryRankingItemSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.RegionalFilteredGalleryRankingItemSchema = zod_1.z.object({
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    action: common_1.CommonResponseItemActionDto.nullish(),
    items: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string(),
        title: zod_1.z.string(),
        discountRate: zod_1.z.string().nullish(),
        price: zod_1.z.object({
            text: zod_1.z.string(),
            isValid: zod_1.z.boolean(),
        }),
        priceUnit: zod_1.z.string().nullish(),
        imageUrl: zod_1.z.string(),
        rank: zod_1.z.string(),
        mobileRatio: zod_1.z.string(),
        action: common_1.CommonResponseItemActionDto,
        logMeta: zod_1.z.record(zod_1.z.unknown()),
    })),
    logMeta: zod_1.z.record(zod_1.z.unknown()).optional(),
});
exports.RegionalFilteredGalleryRankingWidgetDataSchema = zod_1.z.object({
    header: common_1.CommonWidgetV2HeaderDto,
    items: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string(),
        title: zod_1.z.string(),
        action: common_1.CommonResponseItemActionDto.nullish(),
        items: zod_1.z.array(zod_1.z.object({
            action: common_1.CommonResponseItemActionDto,
            badges: zod_1.z.array(common_1.CommonResponseItemPropertyDto),
            benefits: zod_1.z.array(common_1.CommonResponseItemBenefitDto),
            captions: zod_1.z.array(common_1.CommonResponseItemPropertyDto),
            logMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
            descriptions: common_1.CommonResponseItemPropertyDto,
            id: zod_1.z.string(),
            image: common_1.CommonResponseItemImageDto,
            locationDescription: common_1.CommonResponseItemPropertyDto.nullable(),
            locations: zod_1.z.array(common_1.CommonResponseItemPropertyDto),
            prices: zod_1.z.array(zod_1.z.array(common_1.CommonResponseItemPropertyDto)),
            rankingDescription: common_1.CommonResponseItemPropertyDto,
            review: common_1.CommonResponseItemPropertyDto.nullable(),
            titles: zod_1.z.array(common_1.CommonResponseItemPropertyDto),
        })),
        logMeta: zod_1.z.record(zod_1.z.unknown()).optional(),
    })),
    logMeta: zod_1.z.record(zod_1.z.unknown()).optional(),
});
